export var baseServerUrl = 'https://static.beeline.ru/upload/images/carnica';